module.exports = __webpack_public_path__ + "static/media/speed-test-icon.75a0ce2a.svg";